import { SignOutParams } from 'next-auth/react';
import { getHomeLoansDashboardRuntimeConfig } from 'src/services/config/getHomeLoansDashboardRuntimeConfig';
import { getRawLocalStorageItem } from 'src/services/storage/local';
import { zillowSignOut } from './utils/zillowSignOut/zillowSignOut';

declare global {
    // eslint-disable-next-line no-var
    var signOutAlerted: boolean;
}

/**
 * Multiple pathways exist for a session to be forcibly terminated, such as 403 or 401 responses
 * from the GraphQL service, or a failed token refresh from the accounts service. To avoid multiple
 * code paths with conflicting and duplicated logic, this helper function consolidates the logic.
 *
 * When `isDebugMode` is set in local storage in lower environments, it will not signout the user
 *
 * @param justification - Why the session is being terminated. used for debug purposes in lower environments
 */
export const handleInvoluntarySessionTermination = (
    errorMessage: string,
    justification: string,
    config: SignOutParams = {}
) => {
    if (!globalThis.signOutAlerted) {
        globalThis.signOutAlerted = true;
        globalThis.alert(errorMessage);
    }
    const { publicRuntimeConfig } = getHomeLoansDashboardRuntimeConfig();
    if (!publicRuntimeConfig.isLowerEnvironment) {
        zillowSignOut(config);
        return;
    }
    // eslint-disable-next-line no-console
    console.info('Application Sign Out Reason - ', justification);
    if (getRawLocalStorageItem('isDebugMode')) {
        return;
    }
    zillowSignOut(config);
};
